import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class PrimaryMarketSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getPrimaryMarket(data);
    }
}
export default PrimaryMarketSearchUseCase;
